/* jshint esversion: 6 */
/* jshint ignore:start */
import { ToastContainer } from 'react-toastify';
import './App.css';
import Header from './Component/Header';
import "./Style/style.css";
import "./Style/responsive.css";
import { Route, Routes, useLocation } from 'react-router-dom';
import Dashboard from './Component/Dashboard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Categorys_details from './Component/Pages/Categorys_details';
import Details from './Component/Pages/Details';
import Cart from './Component/Pages/Cart';
import Wallet from './Component/Pages/Wallet';
import Profile from './Component/Pages/Profile';
import Success, { Cancel } from './PaymentGateway/PayFastRes';
import Refer from './Component/Pages/Refer';
import Page from './Component/Pages/Page';
import NotFound from './Component/NotFound';
import PaymentResponse from './PaymentGateway/PaymentResponse';
import OrderHistory from './Component/Pages/OrderHistory';
import i18n from "./Component/Language";
import Accessorie from './Component/Pages/Accessorie';
import OrderDetails from './Component/Pages/Order_details';
import Chat from './Component/Pages/Chat';
import Footer from './Component/Footer';
function App() {

  const location = useLocation();

  // useEffect(() => {
  //   const disableShortcuts = (e) => {
  //     if (
  //       e.keyCode === 123 ||
  //       (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) ||
  //       (e.ctrlKey && e.key === "U")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   const disableRightClick = (e) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener("keydown", disableShortcuts);
  //   document.addEventListener("contextmenu", disableRightClick);

  //   return () => {
  //     document.removeEventListener("keydown", disableShortcuts);
  //     document.removeEventListener("contextmenu", disableRightClick);
  //   };
  // }, []);

  const IsShowFooter = location.pathname.startsWith("/chat");

  return (
    <div className="min-h-screen flex flex-col App">
      <Header />

      <div className="flex-grow mt-[85px]">
        <Routes>
          <Route path='/' element={<Dashboard />} />
          <Route path='/category-details' element={<Categorys_details />} />
          <Route path='/details' element={<Details />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/wallet' element={<Wallet />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/referEarn' element={<Refer />} />
          <Route path="/done" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/page/:title" element={<Page />} />
          <Route path="/PaymentRespons" element={<PaymentResponse />} />
          <Route path="/order-history" element={<OrderHistory />} />
          <Route path="/order-details" element={<OrderDetails />} />
          <Route path="/accessorie" element={<Accessorie />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {!IsShowFooter && <Footer />}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>

  );
}

export default App;
/* jshint ignore:end */